<template>
  <div ref="react_wrapper_placeholder" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import renderReactComponent from "./renderReactComponent";
import ReactDOM from "react-dom/client";
import config from "../config";

export default defineComponent({
  name: "ReactWrapper",
  props: {
    domNode: HTMLElement,
    reactComponent: {
      type: Function,
      default: () => {},
    },
    props: {
      type: Object,
      default: () => {},
    },
  },
  // Save non-reactive reference to the React root so we can unmount it later (defining this is data caused errors in builds)
  _reactRoot: null as ReactDOM.Root | null,
  created() {
    // @ts-expect-error _reactRoot does exist, just not reactive
    this._reactRoot = null;
  },
  watch: {
    props: function () {
      const ref = this.domNode || this.$refs?.react_wrapper_placeholder;
      const reactRoot = renderReactComponent(ref, this.reactComponent, this.getReactProps());
      // @ts-expect-error _reactRoot does exist, just not reactive
      this._reactRoot = reactRoot;
    },
  },
  mounted() {
    const ref = this.domNode || this.$refs?.react_wrapper_placeholder;
    const reactRoot = renderReactComponent(ref, this.reactComponent, this.getReactProps());
    // @ts-expect-error _reactRoot does exist, just not reactive
    this._reactRoot = reactRoot;
  },
  beforeDestroy() {
    // Unmount the React component when the Vue component is destroyed, otherwise it will stay in the DOM
    // @ts-expect-error _reactRoot does exist, just not reactive
    this._reactRoot?.unmount();
  },
  methods: {
    getReactProps: function () {
      return {
        ...this.props,
        $store: this.$store,
        $router: this.$router,
        $route: this.$route,
        $t: this.$t,
        messages: this.$i18n.messages,
        locale: this.$i18n.locale,
        clientVersion: config.get("version"),
        partnerProgramKnowledgeBaseURL: config.get("partnerProgramKnowledgeBaseURL"),
        partnerProgramBrandStoreURL: config.get("partnerProgramBrandStoreURL"),
        partnerProgramDashboardCTAURL: config.get("partnerProgramDashboardCTAURL"),
        partnerProgramNPSReportsCTAURL: config.get("partnerProgramNPSReportsCTAURL"),
        partnerProgramPartnerPointsCTAURL: config.get("partnerProgramPartnerPointsCTAURL"),
      };
    },
  },
});
</script>

<style lang="scss"></style>
